import { NEXT_SAMPLE_50_DISCOUNT } from '../components/DiscountBanner';

export interface SampleTotalCostDiscount {
  discounted_price: string;
  id: string;
  original_price: string;
}

const MAX_DISCOUNT_AMOUNT = 250;

const getDiscountLabel = (discount?: SampleTotalCostDiscount) => {
  if (!discount) return null;

  const originalPrice = parseFloat(discount.original_price);
  const discountedPrice = parseFloat(discount.discounted_price);
  const discountAmount = originalPrice - discountedPrice;

  if (discountAmount >= MAX_DISCOUNT_AMOUNT) {
    return `$${MAX_DISCOUNT_AMOUNT} off`;
  }

  if (discount.id === NEXT_SAMPLE_50_DISCOUNT) {
    return '50% off';
  }

  return null;
};

export default getDiscountLabel;
